import React, { Component } from "react";
import Header from "./header";
import MenuBar from "./navbar";
import SocialMediaLinks from "./socialmedialinks";
import Card from "react-bootstrap/Card";
import { Button } from "react-bootstrap";
import { BASE_URL } from "./utility";

class Products extends Component {
  state = {
    products: [
      {
        title: "Wallpapers",
        text: "All kinds of imported wallpapers.",
        href: "/wallpapers",
        img: "download/wallpapers/wall1",
      },
      {
        title: "Wooden Floorings",
        text: "Best quality wooden floorings",
        href: "/woodenfloorings",
        img: "download/woodenfloorings/wood1",
      },
      {
        title: "Claddings",
        text: "All kinds of wall claddings",
        href: "/claddings",
        img: "download/claddings/cladding1",
      },
      {
        title: "Ceilings",
        text: "All kind of false ceilings",
        href: "/ceilings",
        img: "download/ceilings/ceiling1",
      },
      {
        title: "Awnings",
        text: "Wall and window Awnings",
        href: "/awnings",
        img: "download/awnings/awning1",
      },
      {
        title: "Acoustic Baffle Ceilings",
        text: "All kinds of Acoustic Baffle Ceilings",
        href: "/acousticbaffleceilings",
        img: "download/acousticbaffleceilings/acousticbaffleceilings1",
      },
      {
        title: "Wall 2 Wall Carpets",
        text: "Imported wall-2-wall carpets",
        href: "/wall2wall",
        img: "download/wall2wallc/wall2wall1",
      },
      {
        title: "Blinds",
        text: "All kinds of blinds available (wooden blinds).",
        href: "/blinds",
        img: "download/blinds/blinds1",
      },
      {
        title: "Sun Films",
        text: "For best sun shield",
        href: "/solar",
        img: "download/solar/solar1",
      },
      {
        title: "Artificial Grass",
        text: "Lush & Realistic Artificial Grass",
        href: "/agrass",
        img: "download/agrass/agrass1",
      },
      // Add more products as needed...
    ],
  };

  render() {
    return (
      <div
        style={{
          minHeight: "100vh",
          backgroundImage: `url(${BASE_URL}download/general/bg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        <Header />
        <MenuBar />

        <h2
          style={{
            textAlign: "center",
            color: "#fff",
            margin: "2rem 0 1rem",
            fontSize: "2rem",
            fontWeight: 600,
          }}
        >
          Products
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "1.5rem",
            padding: "1rem 2rem 3rem",
            maxWidth: "1400px",
            margin: "0 auto",
          }}
        >
          {this.state.products.map((product, idx) => (
            <Card
              key={idx}
              style={{
                backgroundColor: "rgba(0,0,0,0.6)",
                color: "white",
                border: "none",
                borderRadius: "15px",
                overflow: "hidden",
                transition: "transform 0.3s, box-shadow 0.3s",
              }}
              className="product-card"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.6)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.4)";
              }}
            >
              <Card.Img
                variant="top"
                src={BASE_URL + product.img}
                style={{ height: "180px", objectFit: "cover" }}
              />
              <Card.Body>
                <Card.Title>{product.title}</Card.Title>
                <Card.Text>{product.text}</Card.Text>
                <Button variant="primary" href={product.href}>
                  Explore
                </Button>
              </Card.Body>
            </Card>
          ))}
        </div>

        <SocialMediaLinks />
        <div style={{ height: "2rem" }} />
      </div>
    );
  }
}

export default Products;
